import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.8 10.8H4.2C3.88174 10.8 3.57652 10.6736 3.35147 10.4485C3.12643 10.2235 3 9.91826 3 9.6V4.2C3 3.88174 3.12643 3.57652 3.35147 3.35147C3.57652 3.12643 3.88174 3 4.2 3H9.6C9.91826 3 10.2235 3.12643 10.4485 3.35147C10.6736 3.57652 10.8 3.88174 10.8 4.2V4.8M8.4 7.2H13.8C14.4627 7.2 15 7.73726 15 8.4V13.8C15 14.4627 14.4627 15 13.8 15H8.4C7.73726 15 7.2 14.4627 7.2 13.8V8.4C7.2 7.73726 7.73726 7.2 8.4 7.2Z",
  stroke: "currentColor",
  "stroke-width": "1.2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }